import './Home.css';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay  } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import LabCard from "../../components/LabCard";

import blallogo from "../../assets/images/blallogo.png";
import pathlablogo from "../../assets/images/pathlablogo.png";
import carelogo from "../../assets/images/carelogo.png";
import goyallogo from "../../assets/images/goyallogo.png";
import { Link } from "react-router-dom"; //Link


const labs = [
  {
    id: 1,
    name: "Dr. B. Lal",
    logo: blallogo,
    bgColor: "#E8F5EC",
    link: "/drblal",
  },
  {
    id: 2,
    name: "Dr. Lal PathLabs",
    logo: pathlablogo,
    bgColor: "#FFF0C9",
    link: "/drlalapath",
  },
  {
    id: 3,
    name: "CaresAtHome",
    logo: carelogo,
    bgColor: "#1294892e",
    link: "/labtest",
  },
  {
    id: 4,
    name: "Dr. Goyal's",
    logo: goyallogo,
    bgColor: "#FFE3E3",
    link: "/drblal",
  },
   {
    id: 5,
   name: "Dr. B. Lal",
    logo: blallogo,
    bgColor: "#E8F5EC",
    link: "/drblal",
  },
];


const Laboratory = ({ homeSettings = {} }) => {
  const title = (homeSettings.home_diagnostic_title && homeSettings.home_diagnostic_title.trim() !== '') ? homeSettings.home_diagnostic_title : "Smart Diagnostic Solutions";
  const description = (homeSettings.home_diagnostic_description && homeSettings.home_diagnostic_description.trim() !== '') ? homeSettings.home_diagnostic_description : "Compassionate nursing care, physiotherapy, and bedside assistance tailored for patient comfort, recovery, and daily healthcare support.";
  const link = (homeSettings.home_diagnostic_link && homeSettings.home_diagnostic_link.trim() !== '') ? homeSettings.home_diagnostic_link : "/AllPartners";

  return (
    <div className="laboratory_sec">
        <div className="container-fluid"> 
           <div className="section_heading row align-items-center">
              <div className="content_part col-lg-6 col-sm-8 col-6">
                 <h3>{title}</h3>
                 <p>{description}</p>
              </div>
             <div className="btn_part col-lg-6 col-sm-4 col-6 text-end"> 
                <button className="main_btn" >
                  <Link to={link}>
                    View All <ArrowForwardIosIcon />
                  </Link>
                </button>
              </div>
          </div>



           <div className="lab_outer">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay ]}
                  slidesPerView={4}
                  spaceBetween={16}
                  navigation
                  pagination={{ clickable: true }}
                   autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 4,
                    },
                  }}
                >
                  {labs.map((lab) => (
                    <SwiperSlide key={lab.id}>
                      <LabCard lab={lab} />
                    </SwiperSlide>
                  ))}
                </Swiper>
            </div>
        </div>
    </div>

    
  );
};

export default Laboratory;